import { arrayIncludes } from 'utils';
import { Themes } from 'consts';

const isTheme = (theme) => {
  const themeValues = Object.keys(Themes).map(e => Themes[e]);
  return theme && arrayIncludes(themeValues, theme);
};

export default isTheme;
